/**
 * Feature Flags API
 *
 * Fetches resolved flags for the authenticated user (global defaults + per-user overrides).
 * Uses /features/v1/* endpoints (JWT auth required).
 */

import type { AxiosInstance } from 'axios';

const FEATURES_BASE = '/features/v1';

export interface ResolvedFlags {
  [key: string]: boolean;
}

interface FlagsResponse {
  flags: ResolvedFlags;
}

export interface FeatureFlagsApi {
  getFlags(): Promise<ResolvedFlags>;
}

export function createFeatureFlagsApi(http: AxiosInstance): FeatureFlagsApi {
  return {
    async getFlags() {
      const response = await http.get<FlagsResponse>(`${FEATURES_BASE}/flags`);
      return response.data.flags;
    },
  };
}
